// src/components/CustomNavbar.jsx
import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Button, Container, Col, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { useUser } from '../components/UserContext';
import { auth } from '../utils/firebaseConfig';

const CustomNavbar = ({ toggleTheme, isDarkTheme }) => {
  const user = useUser();
  const [hasActivePlan, setHasActivePlan] = useState(false);

  const handleLogout = async () => {
    await signOut(auth);
  };

  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const currentUser = auth.currentUser;
        if (!currentUser) {
          setHasActivePlan(false);
          return;
        }

        const token = await currentUser.getIdToken();
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/user`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.ok) {
          const data = await res.json();
          const sub = data.activeSubscription;
          const active =
            sub &&
            sub.isActive &&
            sub.endDate &&
            new Date(sub.endDate) > new Date();
          setHasActivePlan(active);
        } else {
          setHasActivePlan(false);
        }
      } catch (err) {
        console.error("Error fetching subscription in navbar:", err);
        setHasActivePlan(false);
      }
    };

    fetchSubscription();
  }, [user]);

  return (
    <Navbar className={`'custom-navbar' ${isDarkTheme ? 'dark-theme' : 'light-theme'}`}>
      <Container fluid>
        <br />
        <Navbar.Brand as={Link} to="/">
          <Image
            style={{ maxWidth: '120px' }}
            src={'/logo-cratepic.svg'}
            alt='logo-cratepic'
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className='justify-content-end'>

          <Nav className='justify-content-end flex-grow-1'>
            <Nav>
              {/* Si NO tiene plan activo → mostrar Pricing */}
              {!hasActivePlan && (
                <Nav.Link as={Link} to="/pricing" className="custom-nav-link">
                  Pricing
                </Nav.Link>
              )}

              {/* Si quieres, también podrías poner un link explícito al plan:
              {hasActivePlan && (
                <Nav.Link as={Link} to="/user" className="custom-nav-link">
                  My plan
                </Nav.Link>
              )} */}
            </Nav>

            {user ? (
              <>
                <Nav.Link as={Link} to="/user" className="custom-nav-link">
                  {user.displayName || user.email}
                </Nav.Link>
                <Col md={1}>
                  <Button
                    variant='secondary'
                    className={`${isDarkTheme ? 'dark-theme' : 'light-theme'}`}
                    onClick={handleLogout}
                  >
                    Logout
                  </Button>
                </Col>
              </>
            ) : (
              <Col md={1} lg={2} className='d-flex'>
                <Button
                  as={Link}
                  to="/login"
                  variant='primary'
                  className={`${isDarkTheme ? 'dark-theme' : 'light-theme'}`}
                  style={{ maxWidth: "150px", marginRight: '10px' }}
                >
                  Login
                </Button>
                <Button
                  as={Link}
                  to="/register"
                  variant='secondary'
                  className={`${isDarkTheme ? 'dark-theme' : 'light-theme'}`}
                  style={{ maxWidth: "150px" }}
                >
                  Register
                </Button>
              </Col>
            )}
          </Nav>

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
